<div class="flex relative flex-col items-center justify-center w-4 h-4 rounded-full bg-zen bg-opacity-10 group info-container cursor-pointer">
    <i class="fa-regular fa-info text-xxs"></i>
    <div class="flex flex-row justify-start h-0 w-full absolute z-10 -bottom-1">
        <div  class="flex flex-col border border-zen border-opacity-10 rounded bg-white p-2 opacity-0 group-hover:opacity-100" style="height:fit-content; width:fit-content">
            <h5 class="text-xxs whitespace-nowrap" *ngFor="let generation of generalService.generations_new"><span
                    class="font-medium">{{generation.name|extract:language}}</span> {{(generation.key + '_years') |
                translate:language:ModuleNames.Shared}}</h5>
        </div>
    </div>

</div>